/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDrawer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M23 1v22H1V1zM7 3H3v18h4zm14 0H9v18h12zm-6 14v2h-4v-2zm4-4v2h-8v-2zm-2-4v2h-6V9zm2-4v2h-8V5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDrawer as Drawer };
